import licenseModule from '../../license.module';

export default licenseModule.component('licenseManageId', {
    template: require('./licenseManageId.component.html'),
    controller: ['$timeout', licenseManageIdComponent],
    bindings: {
        ngModel: '=',
        ngChange: '&',
        current: '<',
        remain: '<',
        label: '<',
        min: '<'
    }
});

function licenseManageIdComponent($timeout) {
    var vm = this;

    vm.changes = function() {
        var current = vm.current || 0;
        vm.max = false;
        var max = vm.remain + current;
        if (vm.ngModel > max) {
            vm.max = true;
        }

        if (vm.ngModel === undefined || vm.ngModel < 0) {
            vm.ngModel = 0;
        }
        $timeout(function() {
            vm.ngChange({ $value: vm.ngModel });
        });
    };

    vm.positiveValue = function(event) {
        var keys = {
            escape: 27,
            backspace: 8,
            tab: 9,
            enter: 13,
            del: 46,
            '0': 48,
            '1': 49,
            '2': 50,
            '3': 51,
            '4': 52,
            '5': 53,
            '6': 54,
            '7': 55,
            '8': 56,
            '9': 57
        };
        for (var index in keys) {
            if (!keys.hasOwnProperty(index)) {
                continue;
            }
            if (event.charCode == keys[index] || event.keyCode == keys[index]) {
                return; // default event
            }
        }
        event.preventDefault();
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-manage-id/licenseManageId.component.js